import React from 'react';
import styled from 'styled-components';

const ContactSection = styled.section`
  padding: 70px;
  color: black;
  max-width: 800px;
  margin: 0 auto;
  font-family: "Garamond", serif;
  background-color: rgb(23, 29, 41);
  margin-top: 20px;

  @media (max-width: 768px) {
    padding: 30px 10px;
  }

  @media (max-width: 480px) {
    padding: 15px 2px;
    margin-top: 12px;
  }
`;

const ContactIcons = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 20px;

  @media (max-width: 600px) {
    flex-direction: column;
    gap: 18px;
    align-items: center;
  }
`;

const ContactIcon = styled.a`
  display: flex;
  align-items: center;
  text-decoration: none;
  color: white;
  font-size: 1.15rem;
  transition: color 0.2s;

  &:hover {
    color: #66c0f4;
  }

  @media (max-width: 480px) {
    font-size: 1rem;
  }
`;

const ContactIconImage = styled.img`
  width: 30px;
  height: 30px;
  margin-right: 10px;

  @media (max-width: 480px) {
    width: 24px;
    height: 24px;
    margin-right: 8px;
  }
`;

const StyledSection = styled.section`
  color: white;
  font-size: 1.2rem;

  @media (max-width: 480px) {
    font-size: 1.05rem;
    text-align: center;
  }
`;

const Contact = () => {
  return (
    <ContactSection id="contact">
      <StyledSection>
        <h1>Connect with me:</h1>
      </StyledSection>
      <ContactIcons>
        <ContactIcon href="https://www.linkedin.com/in/amirthavarshini-v/" target="_blank" rel="noopener noreferrer">
          <ContactIconImage src={`${process.env.PUBLIC_URL}/linkedin.png`} alt="LinkedIn" />
          LinkedIn: amirthavarshini-v
        </ContactIcon>
        <ContactIcon href="https://github.com/Amirtha2503" target="_blank" rel="noopener noreferrer">
          <ContactIconImage src={`${process.env.PUBLIC_URL}/github.png`} alt="GitHub" />
          GitHub: Amirtha2503
        </ContactIcon>
        <ContactIcon href="mailto:amirtha.venkadesh@gmail.com">
          <ContactIconImage src={`${process.env.PUBLIC_URL}/mail.png`} alt="Email" />
          Email: amirtha.venkadesh@gmail.com
        </ContactIcon>
      </ContactIcons>
    </ContactSection>
  );
};

export default Contact;
